import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Button } from '@iag-packages/chroma-react/lib/components';

import { InputFormat } from './chroma';

interface InputFormatProps {
  id: string;
  fieldName: string;
  ariaLabel?: string;
  prefix: string;
  placeholder: string;
  value: string;
  decimalScale: number;
  onChange: Function;
  valid: boolean;
  error: boolean;
  onUpdateClick: () => void;
  ariaRequired?: boolean;
}

export const UpdateInputFormatContainer = styled.div`
  display: flex;
  justify-content: space-between;
  div {
    min-width: 80%;
    input {
      border-right: none !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }
    input.is-valid {
      border-right: none !important;
    }
  }
  button {
    min-width: 20%;
    border-radius: 0px 6px 6px 0px;
  }
`;

export const UpdateInputFormat: FunctionComponent<InputFormatProps> = ({
  id,
  fieldName,
  ariaLabel,
  prefix,
  placeholder,
  value,
  onChange,
  valid,
  error,
  decimalScale,
  onUpdateClick,
  ariaRequired,
}) => (
  <UpdateInputFormatContainer>
    <InputFormat
      id={id}
      name={fieldName}
      aria-label={ariaLabel}
      prefix={prefix}
      placeholder={placeholder}
      decimalScale={decimalScale}
      value={value}
      onChange={onChange}
      valid={valid}
      error={error}
      aria-required={ariaRequired}
    />
    <Button primary disabled={!valid} onClick={onUpdateClick}>
      Update
    </Button>
  </UpdateInputFormatContainer>
);

export default UpdateInputFormat;
